'use strict';

function resizeWindow() {}
function scrollDown() {}

$(document).ready(function () {
	$('.book-direct-popin .button').click(function () {
		$(this).closest('.book-direct-popin').toggleClass('open');
	});

	//Call function with browser is resized.
	$(window).resize(function (event) {
		resizeWindow();
	});
	resizeWindow();

	//Acts when scroll down page.
	$(window).scroll(function (event) {
		scrollDown();
		var top = $(document).scrollTop();
		if (top > 40) {
			$('header').addClass('scroll');
		} else {
			$('header').removeClass('scroll');
		}
	});

	// Main Nav Dropdown
	$("#primary-nav li").hover(function () {

		$(this).addClass("hover");
		$('ul.submenu', this).fadeIn(200);
	}, function () {

		$(this).removeClass("hover");
		$('ul.submenu', this).fadeOut(200);
	});

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function (event) {
		$('body, html').animate({
			scrollTop: $(window).height() - $('header').outerHeight() * 2 }, 800, 'easeOutExpo');
	});

	//Event Tracking
	$('.book-now').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
	});
	$('.bookNow').on('click', function () {
		if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
	});

	//Check in and check out datepicker for booking engine
	$("#CheckIn").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function onSelect(selectedDate) {
			getDate = $(this).datepicker('getDate');
			newDate = new Date(getDate.getTime());
			newDate.setDate(newDate.getDate() + 1);
			$("#CheckOut").datepicker("setDate", newDate);
			$("#CheckOut").datepicker("option", "minDate", selectedDate);
		}
	});
	$("#CheckOut").datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		onSelect: function onSelect(selectedDate) {
			$("#CheckIn").datepicker("option", "maxDate", selectedDate);
		}
	});

	// Map: Return to previous page button. Change body id to match map template's name.
	//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	$('.benefits .btn').click(function (event) {
		event.preventDefault();
		$(this).toggleClass('open');
		$(this).siblings('.info-benefits').slideToggle();
	});

	$('.essentials .btn').click(function (event) {
		event.preventDefault();
		$(this).toggleClass('open');
		$(this).siblings('.info-essentials').slideToggle();
	});

	$('.map-pin').click(function () {
		var thisTitle = $(this).attr('data-title');
		var thisText = $(this).attr('data-text');
		var thisLetter = $(this).text();
		$('.map-text h3').text(thisTitle);
		$('.map-text p').text(thisText);
		$('.map-letter').text(thisLetter);
		$('.map-pin').removeClass('active');
		$(this).addClass('active');
	});

	$('.btn-collapse').click(function () {
		if ($(this).siblings('.content-collapse').is(':hidden')) {
			$('.content-collapse').slideUp();
			$(this).siblings('.content-collapse').slideDown();
			$('.item-collapse').removeClass('open');
			$('.item-collapse').find('.collapse-icon .text').text('open');
			$(this).parent('.item-collapse').find('.collapse-icon .text').text('Close');
			$(this).parent().addClass('open');
		} else {
			$(this).siblings('.content-collapse').slideUp();
			$(this).parent().removeClass('open');
			$(this).parent('.item-collapse').find('.collapse-icon .text').text('open');
		}
	});

	//Remove Attributes
	$('#third-nav').removeAttr('aria-labelledby');
});

$(window).on('load', function () {

	//Slick Slider
	$('.sym-slides').slick();
	$('.reasons-blog .sym-slide').each(function () {
		var thisIndex = $(this).index() + 1;
		$(this).find('.blog-number').text(thisIndex);
	});
});

$(window).bind('load scroll', function () {
	var valScroll = $(window).scrollTop();
	$('.parallax1').each(function () {
		var thisPosition = $(this).parent().offset().top;
		var middleContent = $(window).height() / 2;
		var thisParentHeight = $(this).parent().height() / 2;
		var thisParallax = thisPosition - (valScroll + (middleContent - thisParentHeight));
		$(this).css('transform', 'translateY(' + thisParallax * 0.22 + 'px)');
	});

	$('.parallax2').each(function () {
		var thisPosition = $(this).parent().offset().top;
		var middleContent = $(window).height() / 2;
		var thisParentHeight = $(this).parent().height() / 2;
		var thisParallax = thisPosition - (valScroll + (middleContent - thisParentHeight));
		$(this).css('transform', 'translateY(' + thisParallax * 0.1 + 'px)');
	});

	$('.parallax3').each(function () {
		var thisPosition = $(this).parent().offset().top;
		var middleContent = $(window).height() / 2;
		var thisParentHeight = $(this).parent().height() / 2;
		var thisParallax = thisPosition - (valScroll + (middleContent - thisParentHeight));
		$(this).css('transform', 'translateY(' + thisParallax * 0.04 + 'px)');
	});
});